<template>
  <div>
    <Filters
      :status="currentStatus"
      :activeTab="activeTab"
      routeType="costCenter"
      @change="updateFilters"
      @changePeriod="changePeriod"
    />

    <Table
      :items="items"
      :pagination="pagination"
      :status="currentStatus"
      :clearSelectedItem="clearSelectedItem"
      @reloadData="reloadData"
      @goToPage="updatePage"
      @openDrawer="openDrawer"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import Filters from 'components/reports/Filters'
import Table from './Table'

export default {
  name: 'ReportCostCenter',
  props: {
    activeTab: {
      type: Number,
      default: 0
    },
    clearSelectedItem: {
      type: Boolean
    }
  },
  components: {
    Filters,
    Table
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      claims: ({ userClaims }) => userClaims.claims
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.ReportsPage',
      pagination: {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      },
      filters: {},
      currentStatus: null,
      items: [],
      selectedItem: null
    }
  },
  methods: {
    updatePagination (response, itemsPerPage) {
      const totalPagesCalc = Math.ceil(response.length / itemsPerPage)
      const totalPages = totalPagesCalc > 0 ? totalPagesCalc : 1

      this.pagination = {
        ...this.pagination,
        totalElements: response.length,
        totalPages
      }
    },

    resetPagination () {
      this.pagination = {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      }
    },

    updateFilters (filters) {
      this.filters = { ...filters }
      this.reloadData()
      this.$emit('updateFilters', { type: 'costCenter', filters })
    },

    updatePage (page) {
      scrollTo(0, 0)

      this.pagination = {
        ...this.pagination,
        currentPage: page
      }

      this.loadData()
    },

    async loadData () {
      // prevent new request
      if (this.currentStatus === STATUS_IS_LOADING) return

      this.currentStatus = STATUS_IS_LOADING

      try {
        const { currentPage, itemsPerPage } = this.pagination
        const companyId = this.selectedCompany ? this.selectedCompany.id : null
        const { search, startDate, endDate } = this.filters
        const { data: res } = await this.$apiService.getCostCenters(
          { limit: itemsPerPage },
          { page: currentPage },
          { companyId },

          // filters
          { search },
          { startDate },
          { endDate },
          { orderBy: 'desc' }
        )

        this.items = res.data.series
        this.updatePagination(res, itemsPerPage)
        this.$emit('setReportItems', res.data.series.length)
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    },

    reloadData () {
      this.resetPagination()
      this.loadData()
    },

    openDrawer (item) {
      this.$emit('openDrawer', item)
    },

    changePeriod (period) {
      this.$emit('changePeriod', period)
    }
  },

  watch: {
    selectedCompany () {
      this.reloadData()
    }
  },

  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss">
.route--reports {

  .page__content,
  .v-tabs-reports,
  .v-tabs-reports .v-window,
  .v-tabs-reports .v-window .v-window__container,
  .v-tabs-reports .v-window .v-window__container .v-window-item,
  .v-tabs-reports .v-window .v-window__container .v-window-item > div {
    height: 100%;
  }
}
</style>
